// extracted by mini-css-extract-plugin
export default {"page-loading":"PageLoading_page-loading__z6d94"};